var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-sku',{attrs:{"sku":_vm.sku,"goods":_vm.goods,"goods-id":_vm.goodsId,"show-add-cart-btn":false,"buy-text":"确定"},on:{"buy-clicked":_vm.addOne},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})}
var staticRenderFns = []

export { render, staticRenderFns }